import { OrdersPage } from '@/features/production-orders';

export default function Orders() {
  return <OrdersPage />;
}
